export default "__VITE_ASSET__b651e32a__"